import { render, staticRenderFns } from "./signup-modal-success.vue?vue&type=template&id=01c68b5a&scoped=true&"
import script from "./signup-modal-success.vue?vue&type=script&lang=ts&"
export * from "./signup-modal-success.vue?vue&type=script&lang=ts&"
import style0 from "./signup-modal-success.vue?vue&type=style&index=0&id=01c68b5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c68b5a",
  null
  
)

export default component.exports